import { render, staticRenderFns } from "./ConvoFeedbackReport.vue?vue&type=template&id=563c0e2b&"
import script from "./ConvoFeedbackReport.vue?vue&type=script&lang=js&"
export * from "./ConvoFeedbackReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports